import { Provider as RollbarProvider } from "@rollbar/react";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactDOM from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ErrorBoundary from "./Components/Error/ErrorBoundary";
import { initInstrumentation } from "./Services/instrument";
import { store } from "./store/index.ts";
import "./style/Global.scss";

initInstrumentation();

const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  environment: process.env.REACT_APP_ENV,
  captureUncaught: true,
  captureUnhandledRejections: true,
  captureIp: true,
  captureDeviceInfo: true,
  captureEmail: true,
  captureUsername: true,
  enabled: true,
  payload: {
    clientName: process.env.REACT_APP_NAME || "local",
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <RollbarProvider config={rollbarConfig}>
    <ErrorBoundary>
      <ReduxProvider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ReduxProvider>
    </ErrorBoundary>
  </RollbarProvider>,
);
